/**
 * SortableTaxonomyOption - Wrapper for TaxonomyOptionEditor with drag-and-drop support
 */

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { TaxonomyOptionEditor, type TaxonomyOptionEditorProps } from './TaxonomyOptionEditor';

export function SortableTaxonomyOption(props: Omit<TaxonomyOptionEditorProps, 'isDragging' | 'dragHandleProps'>) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.option.optionId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <TaxonomyOptionEditor
        {...props}
        isDragging={isDragging}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
}
